import React from "react";
import { paramCase } from "change-case";

import { componentNanoid } from "../../utils/componentNanoid";

import HeaderCell from "./HeaderCell";
import { SearchResultsHeader } from "../SearchContents/SearchContents";

export type HeaderRowProps = {
    headers: SearchResultsHeader[];
};

const HeaderRow = ({ headers }: HeaderRowProps) => {
    const maybeHeaders = headers.length
        ? headers.map((header) => {
              const { columnKey } = header;
              const key = columnKey
                  ? `header-${paramCase(columnKey)}`
                  : `header-${componentNanoid()}`;
              return <HeaderCell key={key} {...header} />;
          })
        : null;
    return (
        <thead>
            <tr>{maybeHeaders}</tr>
        </thead>
    );
};

export default HeaderRow;
